import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DashboardState = {
  data: any | null;
  loaded: boolean;
};

const initialState: DashboardState = {
  data: null,
  loaded: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboard(state, action: PayloadAction<any>) {
      state.data = action.payload;
      state.loaded = true;
    },

    clearDashboard(state) {
      state.data = null;
      state.loaded = false;
    },
  },
});

export const { setDashboard, clearDashboard } = dashboardSlice.actions;

export default dashboardSlice.reducer;
